export default __webpack_public_path__ + "static/media/Aura-Egg__06.b148c3d4.png";